import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import AnswerHeader from "components/answer/Header";

import { openConfirmDialog } from "redux/modules/confirmDialog";
import { openMenu, closeMenu } from "redux/modules/answer/answerHeader";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader
});

const mapDispatchToProps = dispatch => ({
  handleLogout: () => {
    const dialogData = {
      title: "確認",
      contentText: "ログアウトします。よろしいですか？",
      btnLabel: "ログアウト",
      handleClick: () => {
        // ステートを初期化するためにリロードする
        window.location.reload();
      }
    };

    dispatch(openConfirmDialog(dialogData));
  },
  openMenu: event => dispatch(openMenu(event)),
  closeMenu: () => dispatch(closeMenu())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AnswerHeader)
);



// WEBPACK FOOTER //
// ./src/containers/answer/AnswerHeaderContainer.js